/** Аудитория помощника (Task 4): зритель на витрине или сотрудник в кабинете. */
export const AUDIENCE_LABELS: Record<"VIEWER" | "PARTNER", string> = {
  VIEWER: "Зритель",
  PARTNER: "Партнёр",
};

/** У старых записей до миграции аудитории нет: это зритель. */
export const audienceLabel = (value: string | null | undefined) =>
  value === "PARTNER" ? AUDIENCE_LABELS.PARTNER : AUDIENCE_LABELS.VIEWER;

export const audienceFilterField = {
  label: "Аудитория",
  type: "select" as const,
  xs: 12,
  md: 6,
  fullWidth: true,
  priority: "primary" as const,
  options: [
    { label: "Все", value: "" },
    { label: AUDIENCE_LABELS.VIEWER, value: "VIEWER" },
    { label: AUDIENCE_LABELS.PARTNER, value: "PARTNER" },
  ],
};
